import { useStoreSystem } from "../../../store";
import { SideType } from "../../../store/types/store";
import convertDegreesToRadians from "../../../utils/convertDegreesToRadians";

function getPolarAngleLimits() {
    const proMode = useStoreSystem.getState().proMode;
    return { min: proMode?convertDegreesToRadians(0):convertDegreesToRadians(2), max: proMode?convertDegreesToRadians(180):convertDegreesToRadians(178) };

}

export default getPolarAngleLimits
